import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  icon?: IconName | ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, icon, className = "" }: EmptyStateProps) {
  return (
    <div
      className={`border border-dashed border-border rounded-lg px-6 py-10 text-center bg-surface ${className}`}
    >
      {icon && (
        <div className="flex justify-center mb-3">
          {typeof icon === "string" ? (
            <span className="w-10 h-10 rounded-full bg-bg-2 flex items-center justify-center text-muted">
              <Icon name={icon as IconName} size={20} />
            </span>
          ) : (
            icon
          )}
        </div>
      )}
      <h3 className="font-serif text-lg font-medium text-text mb-1">{title}</h3>
      {description && <p className="text-sm text-muted mb-4 max-w-md mx-auto">{description}</p>}
      {action}
    </div>
  );
}
